import { create } from 'zustand';
import type { RefObject } from 'react';

interface ModalStore {
  isOpen: boolean;
  modalType: string | null;
  modalData: unknown;
  onSuccess?: () => void;
  triggerRef?: RefObject<HTMLElement | null>;
  openModal: (
    type: string,
    data?: unknown,
    onSuccess?: () => void,
    triggerRef?: RefObject<HTMLElement | null>
  ) => void;
  closeModal: () => void;
}

export const useModalStore = create<ModalStore>((set, get) => ({
  isOpen: false,
  modalType: null,
  modalData: null,
  onSuccess: undefined,
  triggerRef: undefined,
  openModal: (type, data = null, onSuccess = undefined, triggerRef = undefined) =>
    set({ isOpen: true, modalType: type, modalData: data, onSuccess, triggerRef }),
  closeModal: () => {
    const target = get().triggerRef?.current;
    if (target && document.body.contains(target)) {
      target.focus();
    } else {
      document.querySelector<HTMLElement>('[role="grid"][aria-label="Book collection"]')?.focus();
    }
    set({ isOpen: false, modalType: null, modalData: null, onSuccess: undefined, triggerRef: undefined });
  },
}));
